<template>
  <div class="materialDetail">
    <div class="materialDetailTitle">
      <div class="materialDetailTitle-wrap">
        <el-page-header @back="goBack" content="详情页面"> </el-page-header>
      </div>
    </div>
    <div class="materialDetailMain">
      <!--  -->
      <div class="applicantInfoFormItem">
        <div class="formItemLeftTitle">
          <p>法人名称<span>*</span></p>
        </div>
        <div class="formItemRightMain">
          <el-input
            v-model="form.name"
            disabled
            placeholder="请输入企业名称或机构名称"
          ></el-input>
        </div>
      </div>
      <!--  -->
      <div class="applicantInfoFormItem">
        <div class="formItemLeftTitle">
          <p>是否包含外资<span>*</span></p>
        </div>
        <div class="formItemRightMain">
          <el-radio-group v-model="form.nature" disabled
            ><el-radio label="1">是</el-radio>
            <el-radio label="2">否</el-radio></el-radio-group
          >
        </div>
      </div>
      <!--  -->
      <div class="applicantInfoFormItem">
        <div class="formItemLeftTitle">
          <p>备案域名<span>*</span></p>
        </div>
        <div class="formItemRightMain">
          <el-input
            v-model="form.domain"
            disabled
            placeholder="请输入企业名称或机构名称"
          ></el-input>
        </div>
      </div>
      <!--  -->
      <div class="applicantInfoFormItem">
        <div class="formItemLeftTitle">
          <p>营业执照扫描件<span>*</span></p>
        </div>
        <div class="formItemRightMain">
          <uploadFileList
            :disabled="true"
            :successFile="successFile"
            :imgData="imgData"
            typeFile="image"
            :actionUrl="actionUrl"
            :claim="claim1"
            :pFileList="fileList1"
            :fileLength="1"
          />
        </div>
      </div>
      <!--  -->
      <div class="applicantInfoFormItem">
        <div class="formItemLeftTitle">
          <p>域名证书<span>*</span></p>
        </div>
        <div class="formItemRightMain">
          <uploadFileList
            :disabled="true"
            :successFile="successFile"
            :imgData="imgData"
            typeFile="image"
            :actionUrl="actionUrl"
            :claim="claim2"
            :pFileList="fileList2"
            :fileLength="1"
          />
        </div>
      </div>
      <!--  -->
      <div class="line"></div>
      <!--  -->
      <div class="applicantInfoFormItem">
        <div class="formItemLeftTitle">
          <p>法定代表人身份证<span>*</span></p>
        </div>
        <div class="formItemRightMain">
          <uploadFileList
            :disabled="true"
            :successFile="successFile"
            :imgData="imgData"
            typeFile="image"
            :actionUrl="actionUrl"
            :claim="claim3"
            :pFileList="fileList3"
            :fileLength="1"
          />
        </div>
      </div>
      <!--  -->
      <!--  -->
      <div class="applicantInfoFormItem">
        <div class="formItemLeftTitle">
          <p>许可证负责人身份证<span>*</span></p>
        </div>
        <div class="formItemRightMain">
          <uploadFileList
            :disabled="true"
            :successFile="successFile"
            :imgData="imgData"
            typeFile="image"
            :actionUrl="actionUrl"
            :claim="claim3"
            :pFileList="fileList4"
            :fileLength="1"
          />
        </div>
      </div>
      <!--  -->
      <!--  -->
      <div class="applicantInfoFormItem">
        <div class="formItemLeftTitle">
          <p>客服负责人身份证<span>*</span></p>
        </div>
        <div class="formItemRightMain">
          <uploadFileList
            :disabled="true"
            :successFile="successFile"
            :imgData="imgData"
            typeFile="image"
            :actionUrl="actionUrl"
            :claim="claim3"
            :pFileList="fileList5"
            :fileLength="1"
          />
        </div>
      </div>
      <!--  -->
      <!--  -->
      <div class="applicantInfoFormItem">
        <div class="formItemLeftTitle">
          <p>安全负责人身份证<span>*</span></p>
        </div>
        <div class="formItemRightMain">
          <uploadFileList
            :disabled="true"
            :successFile="successFile"
            :imgData="imgData"
            typeFile="image"
            :actionUrl="actionUrl"
            :claim="claim3"
            :pFileList="fileList6"
            :fileLength="1"
          />
        </div>
      </div>
      <!--  -->
      <div class="line"></div>
      <!--  -->
      <div class="applicantInfoFormItem">
        <div class="formItemLeftTitle">
          <p>股东身份证<span>*</span></p>
        </div>
        <div class="formItemRightMain">
          <uploadFileList
            :disabled="true"
            :successFile="successFile"
            :imgData="imgData"
            typeFile="image"
            :actionUrl="actionUrl"
            :claim="claim4"
            :pFileList="fileList7"
            :fileLength="1"
          />
        </div>
      </div>
      <!--  -->
      <div class="line"></div>
      <!--  -->
      <div class="applicantInfoFormItem">
        <div class="formItemLeftTitle">
          <p>预览文件<span>*</span></p>
        </div>
        <div class="formItemRightMain">
          <uploadFileList
            :disabled="true"
            :successFile="successFile"
            :imgData="imgData"
            typeFile="image"
            :actionUrl="actionUrl"
            :claim="claim5"
            :pFileList="fileList8"
            :fileLength="1"
          />
        </div>
      </div>
      <!--  -->
      <!--  -->
      <div class="applicantInfoFormItem">
        <div class="formItemLeftTitle">
          <p>收费方案计划书<span>*</span></p>
        </div>
        <div class="formItemRightMain">
          <uploadFileList
            :disabled="true"
            :successFile="successFile"
            :imgData="imgData"
            typeFile="image"
            :actionUrl="actionUrl"
            :claim="claim6"
            :pFileList="fileList9"
            :fileLength="1"
          />
        </div>
      </div>
      <!--  -->
      <!--  -->
      <div class="applicantInfoFormItem">
        <div class="formItemLeftTitle">
          <p>股东追溯不涉及外资承诺书<span>*</span></p>
        </div>
        <div class="formItemRightMain">
          <uploadFileList
            :disabled="true"
            :successFile="successFile"
            :imgData="imgData"
            typeFile="image"
            :actionUrl="actionUrl"
            :claim="claim6"
            :pFileList="fileList10"
            :fileLength="1"
          />
        </div>
      </div>
      <!--  -->
      <!--  -->
      <div class="applicantInfoFormItem">
        <div class="formItemLeftTitle">
          <p>依法经营电信业务承诺书<span>*</span></p>
        </div>
        <div class="formItemRightMain">
          <uploadFileList
            :disabled="true"
            :successFile="successFile"
            :imgData="imgData"
            typeFile="image"
            :actionUrl="actionUrl"
            :claim="claim6"
            :pFileList="fileList11"
            :fileLength="1"
          />
        </div>
      </div>
      <!--  -->
      <!--  -->
      <div class="applicantInfoFormItem">
        <div class="formItemLeftTitle">
          <p>其他盖章材料</p>
        </div>
        <div class="formItemRightMain">
          <uploadFileList
            :disabled="true"
            :successFile="successFile"
            :imgData="imgData"
            typeFile="image"
            :actionUrl="actionUrl"
            :claim="claim7"
            :pFileList="fileList12"
            :fileLength="1"
          />
        </div>
      </div>
      <!--  -->
      <!--  -->
      <div class="applicantInfoFormItem">
        <div class="formItemLeftTitle">
          <p>其他签字材料</p>
        </div>
        <div class="formItemRightMain">
          <uploadFileList
            :disabled="true"
            :successFile="successFile"
            :imgData="imgData"
            typeFile="image"
            :actionUrl="actionUrl"
            :claim="claim7"
            :pFileList="fileList13"
            :fileLength="1"
          />
        </div>
      </div>
      <!--  -->
      <!--  -->
      <div class="applicantInfoFormItem">
        <div class="formItemLeftTitle">
          <p>其他材料</p>
        </div>
        <div class="formItemRightMain">
          <uploadFileList
            :disabled="true"
            :successFile="successFile"
            :imgData="imgData"
            typeFile="image"
            :actionUrl="actionUrl"
            :claim="claim7"
            :pFileList="fileList14"
            :fileLength="1"
          />
        </div>
      </div>
      <!--  -->
    </div>
  </div>
</template>

<script>
import uploadFileList from '@/components/uploadFileList';
import { getNeedSolutionDetailByUser } from '@/api/alicp.js';
export default {
  components: {
    uploadFileList,
  },
  data() {
    return {
      detailData: {
        Domain: '', //'备案域名',
        CorporateName: '',
        IncludeForeignInvestment: true,
        PartnerBusinessLicense: '', // '营业执照',
        PartnerIdCardList: [], // ['相关人员身份证'],
        PartnerDomainCertificate: '', //'域名证书',
        PartnerPreviewOtherList: [], //['合作方递交其他供预览的件，只能传递ZIP包'],
        PartnerPlan: '', //'收费方案计划书',
        PartnerForeignInvestment: '', //'股东追溯不涉及外资承诺书'
        PartnerLaw: '', // '依法经营电信业务承诺书',
        PartnerStampOtherList: [], //['需要盖章，只能传递1个zip包'],
        PartnerSignOtherList: [], //['需要签字，只能传递1个zip包'],
        PartnerSignAndStampOtherList: [],
      },
      //表单绑定
      form: {
        corporateName: '', //法人名称
        nature: '', //是否包含外资
        domain: '', //备案域名
      },
      //upLoadData
      imgData: {},
      actionUrl: '',
      //文件上传底部提示信息
      claim1: [
        {
          msg: '请上传jpg; jpeg格式的文件',
        },
      ],
      claim2: [
        {
          msg: '请上传jpg; jpeg格式的文件',
        },
      ],
      claim3: [
        {
          msg: '身份证正面和反面放置于同一文件',
        },
        {
          msg: '请上传jpg; jpeg格式的文件',
        },
      ],
      claim4: [
        {
          msg: '上传所有一级股东身份证照片（法人股上传企信息网截图）',
        },
        {
          msg: '身份证正面和反面放置于同一文件',
        },
        {
          msg: '请上传jpg; jpeg格式的文件',
        },
      ],
      claim5: [
        {
          msg: '请上传.zip格式的文件',
        },
        {
          msg: '只能上传一个压缩文件',
        },
        {
          msg: '压缩文件内容需要包含以下文件',
          child: [
            '①服务器托管协议（.jgp格式）',
            '②服务商IDC证（.pdf格式）',
            '③增值电信业务申请表（.pdf格式）',
            '④员工社保证明材料（.pdf格式）',
            '⑤企信网截图（.jpg格式）',
          ],
        },
      ],
      claim6: [
        {
          msg: '请上传.pdf格式的文件',
        },
      ],
      claim7: [
        {
          msg: '请上传.zip格式的文件',
        },
        {
          msg: '只能上传一个压缩文件',
        },
      ],
      //文件列表
      fileList1: [],
      fileList2: [],
      //
      fileList3: [],
      fileList4: [],
      fileList5: [],
      fileList6: [],
      fileList7: [],
      //
      fileList8: [],
      fileList9: [],
      fileList10: [],
      fileList11: [],
      fileList12: [],
      fileList13: [],
      fileList14: [],
    };
  },
  mounted() {
    this.getdetail();
  },
  methods: {
    //getdetail
    getdetail() {
      let params = this.$route.query.solutionNo;
      this.loading = true;
      getNeedSolutionDetailByUser(params).then((res) => {
        this.loading = false;
        if (res.status == 0) {
          this.detailData = res.data.solutionContent.material;
          this.successFile();
        } else {
          this.$message.warning(res.msg);
        }
      });
    },
    goBack() {
      this.$router.go(-1);
    },
    successFile() {
      this.form = {
        corporateName: this.detailData.CorporateName, //法人名称
        nature: this.detailData.IncludeForeignInvestment ? '1' : 2, //是否包含外资
        domain: this.detailData.Domain, //备案域名
      };
      this.fileList1 = [
        {
          name: this.detailData.PartnerBusinessLicense,
          url: this.detailData.PartnerBusinessLicense,
        },
      ];
      this.fileList2 = [
        {
          name: this.detailData.PartnerDomainCertificate,
          url: this.detailData.PartnerDomainCertificate,
        },
      ];
      this.fileList3 = [
        {
          name: this.detailData.PartnerIdCardList[0],
          url: this.detailData.PartnerIdCardList[0],
        },
      ];
      this.fileList4 = [
        {
          name: this.detailData.PartnerIdCardList[1],
          url: this.detailData.PartnerIdCardList[1],
        },
      ];
      this.fileList5 = [
        {
          name: this.detailData.PartnerIdCardList[2],
          url: this.detailData.PartnerIdCardList[2],
        },
      ];
      this.fileList6 = [
        {
          name: this.detailData.PartnerIdCardList[3],
          url: this.detailData.PartnerIdCardList[3],
        },
      ];
      for (var i = 4; i < this.detailData.PartnerIdCardList.length; i++) {
        this.fileList7.push({
          name: this.detailData.PartnerIdCardList[i],
          url: this.detailData.PartnerIdCardList[i],
        });
      }
      this.fileList8 = [
        {
          name: this.detailData.PartnerPreviewOtherList[0],
          url: this.detailData.PartnerPreviewOtherList[0],
        },
      ];
      this.fileList9 = [
        {
          name: this.detailData.PartnerPlan,
          url: this.detailData.PartnerPlan,
        },
      ];
      this.fileList10 = [
        {
          name: this.detailData.PartnerForeignInvestment,
          url: this.detailData.PartnerForeignInvestment,
        },
      ];
      this.fileList11 = [
        {
          name: this.detailData.PartnerLaw,
          url: this.detailData.PartnerLaw,
        },
      ];
      this.fileList12 = [
        {
          name: this.detailData.PartnerStampOtherList[0],
          url: this.detailData.PartnerStampOtherList[0],
        },
      ];
      this.fileList13 = [
        {
          name: this.detailData.PartnerSignOtherList[0],
          url: this.detailData.PartnerSignOtherList[0],
        },
      ];
      this.fileList14 = [
        {
          name: this.detailData.PartnerSignAndStampOtherList[0],
          url: this.detailData.PartnerSignAndStampOtherList[0],
        },
      ];
    },
    //赋值
  },
};
</script>

<style lang="scss">
.materialDetail {
  width: 100%;
  background: #f5f5f6;
  padding-bottom: 1px;
  .materialDetailTitle {
    width: 100%;
    padding: 19px 0;
    background: #fff;
    .materialDetailTitle-wrap {
      width: 1200px;
      margin: 0 auto;
      .el-page-header__left {
        font-size: 18px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        line-height: 22px;
        color: rgba(255, 106, 0, 1);
      }
    }
  }
  .materialDetailMain {
    width: 1200px;
    margin: 20px auto;
    padding: 20px;
    background: #fff;
    .applicantInfoFormItem {
      width: 100%;
      display: flex;
      padding: 16px;
      .formItemLeftTitle {
        width: 438px;
        height: 32px;
        p {
          text-align: right;
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: rgba(0, 0, 0, 0.85);
          line-height: 32px;
          padding-right: 10px;
          span {
            color: #f00;
            margin-left: 5px;
            line-height: 32px;
          }
        }
      }
      .formItemRightMain {
        flex: 1;
        display: flex;
        align-items: center;
        .el-input {
          width: 435px;
          height: 32px;
          border-radius: 4px;
          input {
            width: 100%;
            height: 100%;
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            line-height: 22px;
            padding: 0 12px;
            border: 1px solid rgba(0, 0, 0, 0.15);
          }
        }
        & > span {
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: rgba(0, 0, 0, 0.85);
          line-height: 22px;
          margin-left: 10px;
        }
      }
      .el-radio__input.is-checked .el-radio__inner {
        background: #ff8a01;
        border: 1px solid #ff8a01;
      }
      .el-radio__input.is-checked + .el-radio__label {
        color: #ff8a01;
      }
      .el-radio__inner:hover {
        border-color: #ff8a01;
      }
    }
    .line {
      width: 100%;
      height: 1px;
      border-bottom: 2px dashed #ccc;
      margin: 20px 0;
    }
  }
}
</style>
